import Model from 'mixins/model';

class SiteModel extends Model {
    constructor() {
        super();

        this.set('paths');
        this.set('User');
    }
    isUserLogged() {
        return !!this.get('User').get('type');
    }
};

export let siteModel = new SiteModel();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/SiteModel.js